var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state)?_c('v-select',_vm._b({attrs:{"outlined":"","persistent-hint":"","item-text":"key","item-value":"value"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-select',_vm.attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }